import { IDmQuocTichActionTypes } from "../../action-types/category/IDmQuocTichActions";
import { IDmquocTichReducer } from "../../reducer-model/category/IDmQuocTichReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDmquocTichReducer = {
  status: eReducerStatusBase.is_not_initialization,
  quocTichs: [],
};
export const quocTichReducer = (
  state: IDmquocTichReducer = iniState,
  action: IDmQuocTichActionTypes
): IDmquocTichReducer => {
  switch (action.type) {
    case "QUOC_TICH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "QUOC_TICH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        quocTichs: action.payload,
      };
    case "QUOC_TICH_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
